module.exports = __webpack_public_path__ + "media/Ham.553c1619.mp3";